<smata-page-loader-spinner [fullScreen]="true"></smata-page-loader-spinner>
<div class="h-100">
  <div class="d-flex justify-content-center top-menu-bar">
    <div class="flex-shrink-1 flex-grow-1 bg-white smata-flex-scroll-container">
      <router-outlet />
    </div>
  </div>
</div>
